export default {"src":"/_next/static/media/0x231b7589426ffe1b75405526fc32ac09d44364c4.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};